﻿import MainWindowCuiLayout from './MainWindowCuiLayout';

window.MainWindowCuiLayout = MainWindowCuiLayout;
